<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
          v-model="customer"
          :items="items"
          :loading="autocomplete.isLoading"
          :search-input.sync="autocomplete.search"
          color="black"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="name"
          :label="$vuetify.t('$vuetify.lobis.selectCustomer')"
          :placeholder="$vuetify.t('$vuetify.lobis.queryCustomer')"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
      </v-flex>
      <v-divider></v-divider>
      <v-text-field
          readonly
          name="name"
          label="Auftrag"
          id="id"
          :value="textfieldValue"
          @click="search.dialog = true"
        ></v-text-field>
      <v-dialog
          v-model="search.dialog"
          fullscreen        >
          <v-card>
            <v-toolbar :height="80" dark color="secondary">
            <v-btn icon dark @click="close()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
              Auftrag auswählen..
            </v-toolbar-title>
          </v-toolbar>

            <v-card-title>
              <v-text-field
                name="name"
                label="Auftrag"
                id="id"
                v-model="search.query"
                autocomplete="off"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-iterator
                :items="searchResults"
                row
                wrap
                hide-actions
              >
                <template v-slot:item="props">
                  <v-flex xs12>
                    <v-card class="mb-2" >
                      <v-card-title primary-title class="pt-3 pb-0 clickable" @click="selectSalesOrder(props.item)">
                        <v-layout row>
                          <v-flex pa-1 grow>
                            <div class="subheading">
                              {{ props.item.Fields.DisplayName }}
                            </div>
                            <span class="grey--text">{{ props.item.address ? props.item.address : '-' }}</span>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-dialog>
              <v-divider></v-divider>
        <v-flex xs12>
          <table xs12 v-if="selectedSalesOrder">
          <thead>
            <tr>
              <th class="text-left">Artikel</th>
              <th class="text-left">Beschreibung</th>
              <th class="text-left">Menge</th>
              <th class="text-left">Einheit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in selectedSalesOrder.Collections.Dokumentposition.Data" :key="item.id">
              <td>{{ item.Fields["Artikel.ID"] }}</td>
              <td>{{ item.Fields["BezeichnungDokumentsprache"] }}</td>
              <td>{{ item.Fields["Menge"] }}</td>
              <td>{{ item.Fields["Einheit.DisplayName"] }}</td>

            </tr>
          </tbody>
      </table>
        </v-flex>
    </v-layout>
  </div>
</template>

<script>
import apiCall from '../../utils/api'

export default {
  data () {
    return {
      autocomplete: {
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        search: null
      },
      customer: null,
      orders: [],
      selectedSalesOrder: null,
      search: {
        query: '',
        dialog: false,
        results: []
      }
    }
  },
  computed: {
    items () {
      return this.autocomplete.entries.map(entry => {
        const Description = entry.name

        return Object.assign({}, entry, { Description })
      })
    },
    searchResults () {
      if (this.search.results.length) {
        return this.search.results
      } else {
        return this.orders
      }
    },
    textfieldValue () {
      if (this.selectedSalesOrder) {
        return this.selectedSalesOrder.Fields.DisplayName
      } else {
        return 'Auftrag auswählen..'
      }
    }
  },
  created () {
  },
  watch: {
    'autocomplete.search' (val) {
      // Items have already been requested
      if (this.autocomplete.isLoading) return

      this.autocomplete.isLoading = true

      // Lazily load input items
      apiCall({ url: 'api/customers', method: 'POST', q: val }).then(resp => {
        this.autocomplete.entries = resp
      }).catch(err => {
        console.log(err)
      }).finally(() => (this.autocomplete.isLoading = false))
    },
    'customer' (val) {
      apiCall({ url: 'api/customerhistory/' + val.id, method: 'GET' }).then(resp => {
        this.orders = resp
      }).catch(err => {
        console.log(err)
      }).finally(() => (this.autocomplete.isLoading = false))
    },
    'search.query' (val) {
      this.$search(val, this.orders, { keys: ['name'] }).then(result => {
        this.search.results = result
      })
    }
  },
  methods: {
    selectSalesOrder (order) {
      console.log(order)
      this.selectedSalesOrder = order
      this.close()
    },
    close () {
      this.search.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Service/Customerhistory.vue